<template>
  <div v-if="env.IS_CHAT_VISIBLE" class="pointer-events-none flex justify-end">
    <a
      :href="env.WHATSAPP_URL"
      target="_blank"
      class="pointer-events-auto flex h-[52px] w-[52px] items-center justify-center rounded-full bg-green-600"
      @click="logEvent"
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.012 3.90694C17.0934 2.98274 16.0005 2.24995 14.7968 1.75097C13.593 1.252 12.3022 0.996761 10.9991 1.00003C5.53276 1.00003 1.08552 5.44547 1.08462 10.91C1.08239 12.6489 1.53854 14.3576 2.40709 15.8641L1 21L6.25656 19.6217C7.71039 20.4131 9.33929 20.8279 10.9946 20.8281H10.9991C16.4636 20.8281 20.9108 16.3808 20.9126 10.9172C20.9166 9.61496 20.6623 8.32486 20.1644 7.12156C19.6666 5.91826 18.935 4.82564 18.012 3.90694V3.90694Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.2027 12.7744L12.6645 12.3162C12.8717 12.1127 13.1437 11.9882 13.4331 11.9643C13.7226 11.9405 14.0112 12.0188 14.2489 12.1857C14.7216 12.5179 15.1492 12.8158 15.5471 13.0931C16.1791 13.5324 16.2556 14.4327 15.711 14.9764L15.3022 15.3843M6.57341 6.65543L6.98212 6.24761C7.10919 6.11978 7.26278 6.02141 7.43204 5.95947C7.6013 5.89753 7.78211 5.87353 7.96167 5.88916C8.14123 5.90479 8.31517 5.95967 8.47118 6.04992C8.6272 6.14017 8.76148 6.26359 8.86455 6.41146C9.14093 6.80937 9.43891 7.23699 9.772 7.70962C9.93922 7.9472 10.0178 8.23595 9.9939 8.5255C9.97004 8.81505 9.84532 9.08705 9.64147 9.29406L9.18324 9.75499M15.3022 15.3852C13.6188 17.0605 10.7875 15.6372 8.55306 13.401"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.55581 13.4046C6.32139 11.1693 4.89719 8.33976 6.57346 6.6554M9.18419 9.75586C9.54609 10.3275 10.0115 10.8938 10.5364 11.4195L10.5391 11.4213C11.0639 11.9471 11.6302 12.4116 12.2027 12.7744"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </a>
  </div>
</template>

<script lang="ts" setup>
  import { env } from '@shared/config';
  import { Analytics, AnalyticsEvents } from '@shared/analytics';

  const logEvent = () => {
    Analytics.logEvent({
      event: AnalyticsEvents.WHATS_APP_CLICK, // TODO: Page name
    });
  };
</script>
